<template>
  <span>
    <span v-if="isSelectAllOptionForFilter">(Select All)</span>
    <span
      v-else-if="isStopSale"
      class="kachel-badge red stop-sale-badge"
      :class="{ 'stop-sale-badge--compact': isCompact }"
    >
      <i class="fas fa-exclamation"></i>
    </span>
    <span v-else>-</span>
  </span>
</template>

<script>
export default {
  name: 'CustomIconExclamation',
  props: {
    value: {
      type: [Boolean, null],
      default: null,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // Für den AG-Grid Set-Filter-Renderer, damit das nicht in jeder datei stehlt
    isSelectAllOptionForFilter() {
      return this.params?.value === '(Select All)';
    },
    resolvedValue() {
      if (this.params) {
        return this.params.value !== undefined
          ? this.params.value
          : this.params.data && this.params.data.stopSale;
      }
      return this.value;
    },
    isStopSale() {
      return !this.isSelectAllOptionForFilter && !!this.resolvedValue;
    },
    // Kleinere Box mit Prop oder mit AG-Grid cellRendererParams
    isCompact() {
      return this.compact || !!this.params?.compact;
    },
  },
};
</script>

<style scoped>
/* Icon-Größe innerhalb der Kachel (Basis-Kachel nutzt 12px für Text) */
.stop-sale-badge .fas {
  font-size: 1.1rem;
}
/* Kompakte Variante, z.B. im AG-Grid */
.stop-sale-badge--compact {
  height: 22px;
  min-width: 22px;
  border-radius: 6px;
}
.stop-sale-badge--compact .fas {
  font-size: 0.75rem;
}
</style>
